import { render, staticRenderFns } from "./yonghxy_config.vue?vue&type=template&id=76a0791b&scoped=true"
import script from "./yonghxy_config.vue?vue&type=script&lang=js"
export * from "./yonghxy_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0791b",
  null
  
)

export default component.exports